module.exports = __webpack_public_path__ + "static/media/sure_quote_website_logo.9d05fc9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sure_quote_website_logo.png
// module id = 94
// module chunks = 0